__webpack_require__.p = "/widget-app/_next/";